const { REACT_APP_API_HOST } = process.env

export const getArchiveUrl = (archive = '') => archive && `${REACT_APP_API_HOST}${archive}`
export const removeArchiveUrl = (archive = '') => archive.replace(REACT_APP_API_HOST, '')
